import { NavLink, Outlet } from 'react-router-dom';
import { Activity, Inbox, LayoutDashboard, PhoneCall, Settings, Users } from 'lucide-react';
import { cn } from '@/lib/cn';
import { useAuth } from '@/auth/AuthContext';

const NAV = [
  { to: '/', label: 'Dashboard', icon: LayoutDashboard, end: true },
  { to: '/brief', label: 'Who to call', icon: PhoneCall },
  { to: '/queue', label: 'Draft queue', icon: Inbox },
  { to: '/members', label: 'Members', icon: Users },
  { to: '/admin', label: 'Admin', icon: Settings, requireRole: 'admin' as const },
];

export function AppShell() {
  const { user, hasRole, signOut } = useAuth();

  return (
    <div className="flex min-h-screen bg-muted/30">
      <aside className="hidden w-60 shrink-0 border-r border-border bg-background md:flex md:flex-col">
        <div className="flex h-16 items-center gap-2 border-b border-border px-5 font-semibold tracking-tight">
          <span className="grid h-7 w-7 place-items-center rounded-md bg-primary text-primary-foreground">
            <Activity className="h-4 w-4" />
          </span>
          Chamber Pulse
        </div>

        <nav className="flex flex-col gap-1 p-3">
          {NAV.filter((n) => !n.requireRole || hasRole(n.requireRole)).map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              className={({ isActive }) =>
                cn(
                  'flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium transition-colors',
                  isActive
                    ? 'bg-primary/10 text-primary'
                    : 'text-muted-foreground hover:bg-muted hover:text-foreground',
                )
              }
            >
              <n.icon className="h-4 w-4" />
              {n.label}
            </NavLink>
          ))}
        </nav>

        {user && (
          <div className="mt-auto border-t border-border p-4 text-sm">
            <p className="font-medium leading-tight">{user.name}</p>
            <p className="truncate text-xs text-muted-foreground">{user.email}</p>
            <p className="mt-1 text-xs text-muted-foreground">
              tenant: <span className="font-mono">{user.tenantId}</span>
            </p>
            <button
              type="button"
              onClick={signOut}
              className="mt-3 text-xs font-medium text-primary hover:underline"
            >
              Sign out
            </button>
          </div>
        )}
      </aside>

      <main className="flex-1 overflow-x-hidden">
        <Outlet />
      </main>
    </div>
  );
}
